module.exports = __webpack_public_path__ + "static/media/Partly_Peaceful.da46bf80.gif";